import {
  AfterViewInit,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ClientService } from '@app/core/services/client.service';
import { TitleService } from '@app/core/services/title.service';
import { SessionService } from '@app/security/session.service';
import { Client } from '@app/core/models/client';
import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { MessageDialogComponent } from '@app/shared/message-dialog/message-dialog.component';
import { NotificationAdmin } from './NotificationAdmin';

@Component({
  selector: 'notification-admin',
  templateUrl: './notification-admin.component.html',
  standalone: true,
})
export class NotificationAdminComponent
  implements OnInit, OnDestroy, OnChanges, AfterViewInit
{
  messageDialog: MessageDialogComponent;
  currentClient: Client;
  client: Client;
  clientId: string;
  reactWrapperId: string;
  root: Root = null;

  constructor(
    private sessionService: SessionService,
    private titleService: TitleService,
    private activatedRoute: ActivatedRoute,
    private clientService: ClientService,
  ) {
    this.currentClient = this.sessionService.getCurrentUsersClient();
  }

  ngOnInit(): void {
    this.clientId = this.sessionService.getCurrentUsersClient().id;
    this.clientService.getClient(this.clientId).subscribe({
      next: (client) => {
        this.client = client;
      },
      error: () => {
        this.client = new Client();
      },
    });

    this.reactWrapperId = 'notification-admin-react-wrapper-id';
  }

  ngOnDestroy(): void {
    this.titleService.deactivate();
    this.root.unmount();
  }

  ngOnChanges() {
    this.render();
  }

  protected render() {
    if (this.root) {
      this.root.render(
        React.createElement(NotificationAdmin, {
          clientId: this.clientId,
        }),
      );
    }
  }

  ngAfterViewInit(): void {
    const node = document.getElementById(this.reactWrapperId);
    this.root = createRoot(node);
    this.render();
  }
}
